import React, { Component, PropTypes } from 'react'
import Drawer from 'material-ui/Drawer'
import Divider from 'material-ui/Divider'
import { spacing, typography, zIndex } from 'material-ui/styles'
import { List, ListItem, makeSelectable } from 'material-ui/List'
import muiThemeable from 'material-ui/styles/muiThemeable'
import config from '../config'

const SelectableList = makeSelectable(List)

class NavDrawer extends Component<any, any> {
  static propTypes = {
    docked: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    onChangeList: PropTypes.func.isRequired,
    onRequestChangeNavDrawer: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    style: PropTypes.object
  }

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  }

  handleRequestChangeLink = (event, value) => {
    window.location = value
  }

  handleTouchTapHeader = () => {
    this.context.router.push('/')
    this.props.onRequestChangeNavDrawer(false)
  }

  render () {
    const headerStyle = {
      cursor: 'pointer',
      fontSize: 24,
      color: typography.textFullWhite,
      lineHeight: `${spacing.desktopKeylineIncrement}px`,
      fontWeight: typography.fontWeightLight,
      backgroundColor: this.props.muiTheme.palette.primary1Color,
      paddingLeft: spacing.desktopGutter,
      marginBottom: 8
    }

    const {
      location,
      docked,
      onRequestChangeNavDrawer,
      onChangeList,
      open,
      style
    } = this.props

    return (
      <Drawer
        style={style}
        docked={docked}
        open={open}
        onRequestChange={onRequestChangeNavDrawer}
        containerStyle={{ zIndex: zIndex.drawer - 100 }}
      >
        <div style={headerStyle} onClick={this.handleTouchTapHeader}>
          NCFDD Admin
        </div>
        <SelectableList
          value={location.pathname}
          onChange={onChangeList}
        >
          <ListItem
            primaryText='Write Now'
            primaryTogglesNestedList
            nestedItems={[
              <ListItem primaryText='Groups' value='/write-now/groups' />,
              <ListItem primaryText='Group Members' value='/write-now/members' />,
              <ListItem primaryText='FSP Group Sorting' value='/write-now/fsp-group-sorting' />,
              <ListItem primaryText='Homework' value='/write-now/homework' />,
              <ListItem primaryText='Pages' value='/write-now/pages' />,
              <ListItem primaryText='Private Coaching' value='/write-now/private_coachings' />,
              <ListItem primaryText='Programs' value='/write-now/programs' />,
              <ListItem primaryText='Program Display Config' value='/write-now/display_configs' />,
              <ListItem primaryText='Program Questions' value='/write-now/program_questions' />,
              <ListItem primaryText='Program Timers' value='/write-now/program_timers' />,
              <ListItem primaryText='Questions' value='/write-now/questions' />,
              <ListItem
                primaryText='Comment Bots'
                primaryTogglesNestedList
                value='/write-now/comment-bots'
                nestedItems={[
                  <ListItem primaryText='Comment History' value='/write-now/comment-bots/history/' />
                ]}
              />,
              <ListItem primaryText='Reminders' value='/write-now/reminders' />,
              <ListItem primaryText='Resources' value='/write-now/resources' />,
              <ListItem primaryText='Resource Categories' value='/write-now/resource_categories' />,
              <ListItem primaryText='Sessions' value='/write-now/sessions' />,
              <ListItem primaryText='Session Notifications' value='/write-now/session_notifications' />,
              <ListItem primaryText='Session Restricted Pages' value='/write-now/session_restricted_pages' />,
              <ListItem primaryText='Timer Types' value='/write-now/timer_types' />,
              <ListItem primaryText='Topics' value='/write-now/topics' />
            ]}
          />
          <ListItem
            primaryText='Accounts'
            primaryTogglesNestedList
            nestedItems={[
              <ListItem primaryText='Users' value='/security/users' />,
              <ListItem primaryText='Coach List' value='/security/coach-users' />,
              <ListItem primaryText='Import WriteNow Groups' value='/security/writenow-import' />,
              <ListItem primaryText='Import WriteNow Merge Fields' value='/security/writenow-merge-fields-import' />,
              <ListItem primaryText='Import Member Data' value='/security/member-import' />,
              <ListItem primaryText='Buddy Matches' value='/security/buddy-matches' />,
              <ListItem primaryText='Buddy Requests' value='/security/buddy-requests' />
            ]}
          />
          {config.membershipEnabled && <ListItem
            primaryText='Membership'
            primaryTogglesNestedList
            nestedItems={[
              <ListItem
                primaryText='Institutions'
                value='/membership/institutions'
                primaryTogglesNestedList
                nestedItems={[
                  <ListItem primaryText='Users' value='/membership/institution-users' />,
                  <ListItem primaryText='Memberships' value='/membership/institution-memberships' />,
                  <ListItem primaryText='Import Schools & Colleges' value='/membership/institutions/import-schools' />
                ]}
              />,
              <ListItem primaryText='Plans' value='/membership/membership-plans' />,
              <ListItem primaryText='Individual Memberships' value='/membership/user-memberships' />
            ]}
          />}
          {config.cmsEnabled && <ListItem
            primaryText='CMS'
            primaryTogglesNestedList
            nestedItems={[
              <ListItem
                primaryText='Pages'
                value='/cms/pages'
              />,
              <ListItem
                primaryText='Fixed Pages'
                primaryTogglesNestedList
                nestedItems={[
                  <ListItem primaryText='Institution Landing Page' value='/cms/fixed-pages/institution-landing-page' />,
                  <ListItem primaryText='FSP' value='/cms/fixed-pages/fsp' />,
                  <ListItem primaryText='14-Day Writing Challenge' value='/cms/fixed-pages/writing-challenge' />,
                  <ListItem primaryText='Alumni' value='/cms/fixed-pages/alumni' />,
                  <ListItem primaryText='Generic Session' value='/cms/fixed-pages/generic' />,
                  <ListItem primaryText='Contact Page' value='/cms/fixed-pages/contact-page' />,
                  <ListItem primaryText='Events Page' value='/cms/fixed-pages/events-page' />
                ]}
              />,
              <ListItem
                primaryText='Posts'
                value='/cms/posts'
              />,
              <ListItem
                primaryText='Public Navigation Menu'
                value='/settings/services_menu'
              />,
              <ListItem
                primaryText='Member Navigation Menu'
                value='/settings/resources_menu'
              />,
              <ListItem
                primaryText='About Us Menu'
                value='/settings/about_us_menu'
              />,
              <ListItem
                primaryText='Redirects'
                value='/settings/redirects'
              />
            ]}
          />}
          {config.eventsEnabled && <ListItem
            primaryText='Events'
            primaryTogglesNestedList
            nestedItems={[
              <ListItem
                primaryText='Multi-Week Courses'
                value='/events/courses'
              />,
              <ListItem
                primaryText='Curriculums'
                value='/events/curriculums'
              />,
              <ListItem
                primaryText='Guest Webinars'
                value='/events/webinars'
              />,
              <ListItem
                primaryText='Categories'
                value='/events/categories'
              />,
              <ListItem
                primaryText='Session Sales'
                value='/events/session-sales'
              />,
              <ListItem
                primaryText='Import Webinar Registrations'
                value='/events/webinars/import-registrations'
              />,
              <ListItem
                primaryText='Import Tags'
                value='/events/webinars/import-tags'
              />
            ]}
          />}
          {config.ecommerceEnabled && <ListItem
            primaryText='Ecommerce'
            primaryTogglesNestedList
            nestedItems={[
              <ListItem
                primaryText='Orders'
                value='/ecommerce/orders'
              />,
              <ListItem
                primaryText='Transactions'
                value='/ecommerce/transactions'
              />,
              <ListItem
                primaryText='Products'
                value='/ecommerce/products'
                nestedItems={[
                  <ListItem
                    primaryText='Product Categories'
                    value='/ecommerce/categories'
                  />,
                  <ListItem
                    primaryText='Link Product Categories'
                    value='/ecommerce/product-categories'
                  />,
                  <ListItem
                    primaryText='Import Product Categories'
                    value='/ecommerce/products/import-product-categories'
                  />
                ]}
              />,
              <ListItem
                primaryText='Discounts'
                value='/ecommerce/discounts'
                primaryTogglesNestedList
                nestedItems={[
                  <ListItem
                    primaryText='Link Product Discounts'
                    value='/ecommerce/product-discounts'
                  />,
                  <ListItem
                    primaryText='Link Category Discounts'
                    value='/ecommerce/category-discounts'
                  />,
                  <ListItem
                    primaryText='Promo Codes'
                    value='/ecommerce/promo-codes'
                  />
                ]}
              />
            ]}
          />}
          {config.mediaEnabled &&
            <ListItem primaryText='Media' value='/media' />}
          <ListItem primaryText='Reports' value='/reports' />
          {config.settingsEnabled &&
            <ListItem
              primaryText='Settings'
              value='/settings'
              primaryTogglesNestedList
              nestedItems={[
                <ListItem
                  primaryText='Profile Fields'
                  primaryTogglesNestedList
                  nestedItems={[
                    <ListItem primaryText='Title' value='/settings/profile_fields/title' />,
                    <ListItem primaryText='Discipline' value='/settings/profile_fields/discipline' />,
                    <ListItem primaryText='Discipline Classification' value='/settings/profile_fields/discipline_classification' />,
                    <ListItem primaryText='Post Nominal Letters' value='/settings/profile_fields/post_nominal_letter' />,
                    <ListItem primaryText='Gender' value='/settings/profile_fields/gender' />,
                    <ListItem primaryText='Ethnicity' value='/settings/profile_fields/ethnicity' />
                  ]}
                />,
                <ListItem
                  primaryText='Universities'
                  value='/settings/universities'
                />,
                <ListItem
                  primaryText='Affirmations'
                  value='/settings/affirmations'
                />
              ]}
            />}
          <ListItem primaryText='Admin Audit' value='/admin-audit' />
        </SelectableList>
        <Divider />
        <SelectableList value='' onChange={this.handleRequestChangeLink}>
          <ListItem primaryText='Logout' value='/logout' />
        </SelectableList>
      </Drawer>
    )
  }
}

export default muiThemeable()(NavDrawer)
